export default "__VITE_ASSET__DXfRld49__"